import { useLocale as e } from "../hooks/useLocale.mjs";
import { useCallback as t } from "react";
import { DAYS_OF_WEEK as n, getWeekdayNames as r } from "@maat/datetime";
//#region src/enums/useTrDayOfWeek.ts
var i = () => {
	let { locale: i } = e();
	return t((e) => r(i, "long")[n.indexOf(e)], [i]);
};
//#endregion
export { i as useTrDayOfWeek };
